import { render } from "./topHoldingBallots.vue?vue&type=template&id=5012f582"
import script from "./topHoldingBallots.vue?vue&type=script&lang=js"
export * from "./topHoldingBallots.vue?vue&type=script&lang=js"

import "./topHoldingBallots.vue?vue&type=style&index=0&id=5012f582&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__